const hopeWorkTimingItems = [
  { label: 'できるだけ早く', value: 1 },
  { label: '3か月以内', value: 2 },
  { label: '決めていない・わからない', value: 0 }
]

export default {
  data: function () {
    return {
      hopeWorkTimingItems
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/HopeWorkTimingMixin.js